<template>
    <div class="grey lighten-3 workspace pt-2 pb-15" v-if="allLVsLoaded">
        <!--<p class="title pa-3">Passreferent</p>-->
        <v-col cols="12">
            <paesse-drucken/>
        </v-col>
        <v-col cols="12" class="mb-2">
            <kugel-paesse/>
        </v-col>
        <!--
        <v-row no-gutters>
            <v-col xl="6" lg="6" md="6" sm="6" xs="12" class="mb-5">
                <paesse-downloads></paesse-downloads>
            </v-col>
            <v-col lx="6" lg="6" md="6" sm="6" xs="12" class="mb-5 d-flex align-stretch">
                <paesse-uploads @snack="showSnack"></paesse-uploads>
            </v-col>
        </v-row>

        <snackbar :msg="infoSnack" style="position: fixed; bottom: 0"></snackbar>-->
        <v-row no-gutters>
            <v-col cols="12" class="mb-5">
                <paesse-leihe @loadLeihSpielerList="bindRealtimeListLeihspieler"></paesse-leihe>
            </v-col>
            <v-col cols="12" class="mb-5">
                <paesse-info-neu></paesse-info-neu>
            </v-col>
            <!--
            <v-col cols="12" class="mb-5">
                <paesse-info></paesse-info>
            </v-col>

            <v-col cols="12" class="mb-5">
                <paesse-manuell title="Pass-Duplikate"
                                tableKey="passDuplikat" icon="mdi-card-account-details">
                </paesse-manuell>
            </v-col>
            <v-col cols="12" class="mb-5">
                <paesse-manuell title="Datenänderungen"
                                tableKey="edit" icon="mdi-account-edit">
                </paesse-manuell>
            </v-col>
            -->
        </v-row>
    </div>
</template>

<script>
    //import PaesseDownloads from "./paesseDownloads";
    //import PaesseUploads from "./paesseUploads";
    //import PaesseManuell from "./paesseManuell";
    import Snackbar from "../../components/elements/snackbar";
    //import PaesseInfo from "./paesseInfo";
    import PaesseLeihe from "./paesseLeihe";
    import PaesseDrucken from "@/views/paesse/drucken/paesseDrucken";
    import PaesseInfoNeu from "@/views/paesse/paesseInfoNeu";
    import KugelPaesse from "@/views/kugeln/paesse/kugelPaesse";
    import store from "@/store/store";

    export default {
        computed: {
            allLVsLoaded(){
                const lvs = this.$store.state.realtime.landesverbaende
                return lvs[11]&&lvs[12]&&lvs[13]&&lvs[14]&&lvs[15]&&lvs[16]&&lvs[17]&&lvs[18]&&lvs[19]&&
                       lvs[21]&&lvs[22]&&lvs[23]&&lvs[24]&&lvs[25]&&lvs[26]&&lvs[27]&&lvs[28]&&lvs[29]
            }
        },
        components: {
            KugelPaesse,
            PaesseInfoNeu,
            PaesseDrucken,
            PaesseLeihe,
            //PaesseInfo,
            Snackbar,
            //PaesseManuell,
            //PaesseUploads,
            //PaesseDownloads
        },
        name: "paesse",
        /*created(){
            this.bindRealtimeLists();
        },
        data: () => ({
            infoSnack: {
                show: false,
                color: 'error',
                timeout: 4000,
                text: '',
                dynamicText: null,
                actionButtonI18n: '',
            },
            paramsDuplikate: {
                collection: 'spieler_actions',
                queryField: 'status_duplikat_pending',
                queryOperator: '==',
                queryValue: true,
            },
            paramsEdit: {
                collection: 'spieler_actions',
                queryField: 'status_edit_pending',
                queryOperator: '==',
                queryValue: true,
            },
        }),*/
        created(){
            this.verifyLVs()
        },
        methods: {
            verifyLVs(){
                Object.keys(this.$store.state.realtime.landesverbaende).forEach( (lvId) => {
                    if ( !store.state.realtime.landesverbaende[lvId]) {
                        this.bindLV(lvId)
                    }
                });
            },
            bindLV(id){
                store.dispatch('bindRealtimeDocument', {
                    collection: 'landesverbaende',
                    docId: id,
                    storeField: 'landesverbaende.' + id,
                });
            },
            /*
            showSnack(color, text){
                this.infoSnack.color = color;
                this.infoSnack.text = text;
                this.infoSnack.show = true;
            },
            bindRealtimeLists(){
                this.$store.dispatch('bindRealtimeList', {
                    collection: 'spieler',
                    queryField: 'search.passStatus',
                    queryOperator: '==',
                    queryValue: 'beantragt',
                    //docId: this.id,
                    storeField: 'pendingNewMitglieder',
                });
                this.$store.dispatch('bindRealtimeList', {
                    collection: 'spieler',
                    queryField: 'search.passStatus',
                    queryOperator: '==',
                    queryValue: 'in Bearbeitung',
                    //docId: this.id,
                    storeField: 'pendingPassUploads',
                });
                this.$store.dispatch('bindRealtimeList', {
                    collection: 'spieler_actions',
                    queryField: 'processedBy',
                    queryOperator: '==',
                    queryValue: '',
                    storeField: 'pendingActionsAll',
                });
            },
            */
            bindRealtimeListLeihspieler(sportJahr){
                this.$store.dispatch('bindRealtimeList', {
                    collection: 'spieler',
                    queryField: 'search.leihen.'+sportJahr,
                    queryOperator: '!=',
                    queryValue: '',
                    storeField: 'pendingLeihspieler',
                });
            }
        },
    }
</script>

<style scoped>
    .workspace{height: 100%; position: fixed; top: 48px; width: 100%; bottom: 0; overflow-y: auto}
</style>